"use client";

import { fallbackLng } from "@/app/i18n/settings";

import type { ResponsePromotionList } from "./promotionServiceInterface/getPromotionListInterface";
import { PromotionProductTypeEnum } from "./promotionServiceInterface/getPromotionListInterface";

export const getPromotionData = async (
  type: PromotionProductTypeEnum,
  category: number | undefined,
): Promise<ResponsePromotionList | null> => {
  const lang = window.location.pathname.split("/")[1] || fallbackLng;

  try {
    if (category) {
      switch (category) {
        case 1:
          return await import(
            `@/public/api/${lang}/v2/promotion/promotionLists/category/coupon.json`
          ).then((m) => m.default);
        case 2:
          return await import(
            `@/public/api/${lang}/v2/promotion/promotionLists/category/creditCard.json`
          ).then((m) => m.default);
        case 3:
          return await import(
            `@/public/api/${lang}/v2/promotion/promotionLists/category/specialDeal.json`
          ).then((m) => m.default);
        default:
          return null;
      }
    }

    switch (type) {
      case PromotionProductTypeEnum.HOME:
        return await import(
          `@/public/api/${lang}/v2/promotion/promotionLists/type/home.json`
        ).then((m) => m.default);
      case PromotionProductTypeEnum.HOTEL:
        return await import(
          `@/public/api/${lang}/v2/promotion/promotionLists/type/hotel.json`
        ).then((m) => m.default);
      case PromotionProductTypeEnum.FLIGHT:
        return await import(
          `@/public/api/${lang}/v2/promotion/promotionLists/type/flight.json`
        ).then((m) => m.default);
      case PromotionProductTypeEnum.TOUR:
        return await import(
          `@/public/api/${lang}/v2/promotion/promotionLists/type/tour.json`
        ).then((m) => m.default);
      case PromotionProductTypeEnum.TICKET:
        return await import(
          `@/public/api/${lang}/v2/promotion/promotionLists/type/ticket.json`
        ).then((m) => m.default);
      case PromotionProductTypeEnum.CAR:
        return await import(
          `@/public/api/${lang}/v2/promotion/promotionLists/type/car.json`
        ).then((m) => m.default);
      default:
        return null;
    }
  } catch (error) {
    // console.error(error);
    return null;
  }
};
